const courses = {
  en: {
    // Courses.js
    title: 'Courses',
    subtitle: 'Create, edit, and manage every course in your catalogue.',
    createButton: 'Create course',
    statTotal: 'All courses',
    statPublished: 'Published',
    statDrafts: 'Drafts',
    statEnrollments: 'Enrollments',
    searchPlaceholder: 'Search courses...',
    clearSearch: 'Clear search',
    filterAllPrices: 'All prices',
    filterPaidOption: 'Paid',
    filterFreeOption: 'Free',
    filterByPriceAria: 'Filter by price',
    sortNewest: 'Newest first',
    sortOldest: 'Oldest first',
    sortTitleAsc: 'Title: A–Z',
    sortTitleDesc: 'Title: Z–A',
    sortPriceHighLow: 'Price: high to low',
    sortPriceLowHigh: 'Price: low to high',
    sortAria: 'Sort',
    resultsMeta: '{shown} of {total}',
    countMeta: '{n} course|{n} courses',
    errorTitle: "Couldn't load courses",
    errorDescription: 'Please check your connection and try again.',
    loadingMessage: 'Loading courses...',
    noMatchTitle: 'No matching courses',
    noMatchDescription: 'Try adjusting your filters or clearing the search to see more courses.',
    clearFilters: 'Clear filters',
    emptyTitle: 'No courses yet',
    emptyDescription: 'Create your first course to start building your catalogue and welcome students.',
    emptyCreateButton: 'Create course',
    statusPublished: 'Published',
    statusDraft: 'Draft',
    cardLessons: '{n} lesson|{n} lessons',
    cardStudents: '{n} student|{n} students',
    cardTests: '{n} test|{n} tests',
    menuEdit: 'Edit',
    menuAria: 'Actions for {title}',
    menuPublish: 'Publish',
    menuUnpublish: 'Unpublish',
    publishedToast: 'Course published',
    unpublishedToast: 'Course unpublished',
    publishFailed: 'Failed to change the publish status',
    publishPermissionError: 'Only administrators can publish or unpublish courses',
    deleteDialogTitle: 'Delete this course?',
    deleteDialogBody: 'will be deleted with all its lessons, tests and enrollments. This cannot be undone.',
    dismissAria: 'Dismiss',
    cancel: 'Cancel',
    delete: 'Delete',
    deletePermissionError: 'You do not have permission to delete courses',
    deletedToast: 'Course deleted',
    noAccess: "You don't have access to this data.",
    deleteFailed: 'Failed to delete course',

    // SkillsPrerequisitesTab.js
    removeSkillAria: 'Remove skill {name}',
    searchOrCreateSkillPlaceholder: 'Search or create a skill...',
    addSkillDialogAria: 'Add skill',
    createSkillOption: 'Create "{query}"',
    startTypingSkills: 'Start typing to search skills',
    skillsCatalogueUnavailableTitle: 'Skills catalogue unavailable',
    skillsCatalogueUnavailableDesc: "We couldn't load the shared list of skills right now. You can still type a name below to create and attach a new one.",
    durationNow: 'now',
    durationLessThanMinute: 'less than a minute',
    durationHourOne: '1 hour',
    durationHoursCount: '{count} hours',
    durationMinuteOne: '1 minute',
    durationMinutesCount: '{count} minutes',
    durationCombined: '{hourPart} and {minutePart}',
    reanalyzeModalTitle: 'Re-analyze with AI',
    reanalyzeModalBody1: 'This will regenerate AI proposals for skills and prerequisites on ',
    reanalyzeModalBodyBold: 'unreviewed modules',
    reanalyzeModalBody2: ' in this course. Reviewed modules will not be modified.',
    reanalyzeModalBody3: 'The analysis takes approximately 1–2 minutes. You can continue using the platform while it runs.',
    reanalyzeModalNote: 'Re-analysis is rate-limited to once per 24 hours per course.',
    starting: 'Starting…',
    runAnalysis: 'Run analysis',
    aiProposedPill: 'AI proposed',
    aiProposedSkillsTooltip: 'Skills were proposed by AI and have not been reviewed',
    reviewedPill: 'Reviewed',
    marking: 'Marking…',
    markReviewed: 'Mark reviewed',
    noSkillsAssigned: 'No skills assigned',
    addSkillButton: 'Add skill',
    addSkillToModuleAria: 'Add skill to this module',
    aiProposedPrereqTooltip: 'Prerequisites were proposed by AI and have not been reviewed',
    aiPillShort: 'AI',
    none: 'None',
    removePrerequisiteAria: 'Remove prerequisite {title}',
    selectModulePlaceholder: 'Select module...',
    addButton: 'Add',
    processingEllipsis: '…',
    noEarlierModules: 'No earlier modules',
    loadingSkillsPrereqs: 'Loading skills and prerequisites…',
    tryAgain: 'Try again',
    loadSkillsFailed: 'Failed to load skills data',
    addSkillFailed: 'Failed to add skill',
    removeSkillFailed: 'Failed to remove skill',
    markReviewedFailed: 'Failed to mark as reviewed',
    addPrerequisiteFailed: 'Failed to add prerequisite',
    removePrerequisiteFailed: 'Failed to remove prerequisite',
    markPrerequisitesReviewedFailed: 'Failed to mark prerequisites reviewed',
    acceptAllSkillsFailed: 'Failed to accept all skills',
    aiAnalyzingBanner: 'AI is analyzing this course…',
    startedAgoOne: '(started 1 minute ago)',
    startedAgoCount: '(started {count} minutes ago)',
    jobTimedOutBanner: 'Job may have failed — check back later or try re-analyzing.',
    reanalyzeRunningTooltip: 'Re-analysis is already running',
    rateLimitedTooltip: 'Rate limited. Try again in {countdown}',
    reanalyzeTooltip: 'Re-analyze skills and prerequisites with AI',
    reanalyzeButton: 'Re-analyze with AI',
    reanalyzingElapsed: 'Re-analyzing… ({seconds}s)',
    reanalyzeAvailableIn: 'Re-analyze available in {countdown}',
    skillsHeading: 'Skills',
    skillsSubtitle: 'Skills assigned to each module. AI-proposed chips are marked until reviewed.',
    accepting: 'Accepting…',
    acceptAll: 'Accept all',
    noUnreviewedModules: 'No unreviewed modules',
    acceptAllTooltip: 'Accept all AI-proposed skills',
    noModulesFound: 'No modules found. Add modules to this course first.',
    prerequisitesHeading: 'Prerequisites',
    prerequisitesSubtitle: 'Define which modules must be completed before others. Only earlier modules (lower order index) can be set as prerequisites.',
    hideGraph: 'Hide graph',
    showGraph: 'Show graph',
    noPrereqEdges: 'No prerequisite edges defined yet.',
    needTwoModules: 'At least two modules are needed to define prerequisites.',
    colModule: 'Module',
    colRequires: 'Requires',
    colAddPrerequisite: 'Add prerequisite',
    colReview: 'Review',
    dagModuleFallback: 'Module {index}',
    reanalyzeStartedToast: 'Re-analysis started. Results in 1-2 minutes.',
    rateLimitedToast: 'Rate limited. Try again in {phrase}.',
    rateLimitedDailyToast: 'You can re-analyze once per day. Try again tomorrow.',
    aiDisabledToast: 'AI features are currently disabled. Contact your administrator.',
    reanalyzeNoPermissionToast: "You don't have permission to re-analyze this course.",
    reanalyzeFailedToast: 'Re-analysis failed: {msg}',
    unknownErrorFallback: 'Unknown error',
  },
  ru: {
    // Courses.js
    title: 'Курсы',
    subtitle: 'Создавайте, редактируйте и управляйте всеми курсами в каталоге.',
    createButton: 'Создать курс',
    statTotal: 'Все курсы',
    statPublished: 'Опубликовано',
    statDrafts: 'Черновики',
    statEnrollments: 'Записи',
    searchPlaceholder: 'Поиск курсов...',
    clearSearch: 'Очистить поиск',
    filterAllPrices: 'Все цены',
    filterPaidOption: 'Платный',
    filterFreeOption: 'Бесплатный',
    filterByPriceAria: 'Фильтр по цене',
    sortNewest: 'Сначала новые',
    sortOldest: 'Сначала старые',
    sortTitleAsc: 'Название: А–Я',
    sortTitleDesc: 'Название: Я–А',
    sortPriceHighLow: 'Цена по убыванию',
    sortPriceLowHigh: 'Цена по возрастанию',
    sortAria: 'Сортировка',
    resultsMeta: '{shown} из {total}',
    countMeta: '{n} курс|{n} курса|{n} курсов',
    errorTitle: 'Не удалось загрузить курсы',
    errorDescription: 'Проверьте подключение и попробуйте ещё раз.',
    loadingMessage: 'Загрузка курсов...',
    noMatchTitle: 'Курсы не найдены',
    noMatchDescription: 'Попробуйте изменить фильтры или очистить поиск, чтобы увидеть больше курсов.',
    clearFilters: 'Сбросить фильтры',
    emptyTitle: 'Пока нет курсов',
    emptyDescription: 'Создайте свой первый курс, чтобы начать формировать каталог и приветствовать студентов.',
    emptyCreateButton: 'Создать курс',
    statusPublished: 'Опубликован',
    statusDraft: 'Черновик',
    cardLessons: '{n} урок|{n} урока|{n} уроков',
    cardStudents: '{n} студент|{n} студента|{n} студентов',
    cardTests: '{n} тест|{n} теста|{n} тестов',
    menuEdit: 'Изменить',
    menuAria: 'Действия: {title}',
    menuPublish: 'Опубликовать',
    menuUnpublish: 'Снять с публикации',
    publishedToast: 'Курс опубликован',
    unpublishedToast: 'Курс снят с публикации',
    publishFailed: 'Не удалось изменить статус публикации',
    publishPermissionError: 'Публиковать курсы и снимать их с публикации могут только администраторы',
    deleteDialogTitle: 'Удалить курс?',
    deleteDialogBody: 'будет удалён вместе со всеми уроками, тестами и записями. Это действие нельзя отменить.',
    dismissAria: 'Закрыть',
    cancel: 'Отмена',
    delete: 'Удалить',
    deletePermissionError: 'У вас нет прав на удаление курсов',
    deletedToast: 'Курс удалён',
    noAccess: 'У вас нет доступа к этим данным.',
    deleteFailed: 'Не удалось удалить курс',

    // SkillsPrerequisitesTab.js
    removeSkillAria: 'Удалить навык {name}',
    searchOrCreateSkillPlaceholder: 'Найдите или создайте навык...',
    addSkillDialogAria: 'Добавить навык',
    createSkillOption: 'Создать «{query}»',
    startTypingSkills: 'Начните вводить, чтобы найти навыки',
    skillsCatalogueUnavailableTitle: 'Каталог навыков недоступен',
    skillsCatalogueUnavailableDesc: 'Не удалось загрузить общий список навыков. Вы всё ещё можете ввести название ниже, чтобы создать и прикрепить новый навык.',
    durationNow: 'сейчас',
    durationLessThanMinute: 'менее минуты',
    durationHourOne: '1 час',
    durationHoursCount: '{count} ч.',
    durationMinuteOne: '1 минута',
    durationMinutesCount: '{count} мин.',
    durationCombined: '{hourPart} и {minutePart}',
    reanalyzeModalTitle: 'Повторный анализ с помощью ИИ',
    reanalyzeModalBody1: 'Это заново сгенерирует предложения ИИ по навыкам и предварительным требованиям для ',
    reanalyzeModalBodyBold: 'непроверенных модулей',
    reanalyzeModalBody2: ' в этом курсе. Проверенные модули изменены не будут.',
    reanalyzeModalBody3: 'Анализ занимает примерно 1–2 минуты. Вы можете продолжать пользоваться платформой, пока он выполняется.',
    reanalyzeModalNote: 'Повторный анализ ограничен одним разом в 24 часа на курс.',
    starting: 'Запуск…',
    runAnalysis: 'Запустить анализ',
    aiProposedPill: 'Предложено ИИ',
    aiProposedSkillsTooltip: 'Навыки были предложены ИИ и ещё не проверены',
    reviewedPill: 'Проверено',
    marking: 'Отметка…',
    markReviewed: 'Отметить как проверено',
    noSkillsAssigned: 'Навыки не назначены',
    addSkillButton: 'Добавить навык',
    addSkillToModuleAria: 'Добавить навык к этому модулю',
    aiProposedPrereqTooltip: 'Предварительные требования были предложены ИИ и ещё не проверены',
    aiPillShort: 'ИИ',
    none: 'Нет',
    removePrerequisiteAria: 'Удалить предварительное требование {title}',
    selectModulePlaceholder: 'Выберите модуль...',
    addButton: 'Добавить',
    processingEllipsis: '…',
    noEarlierModules: 'Нет более ранних модулей',
    loadingSkillsPrereqs: 'Загрузка навыков и предварительных требований…',
    tryAgain: 'Повторить',
    loadSkillsFailed: 'Не удалось загрузить данные о навыках',
    addSkillFailed: 'Не удалось добавить навык',
    removeSkillFailed: 'Не удалось удалить навык',
    markReviewedFailed: 'Не удалось отметить как проверено',
    addPrerequisiteFailed: 'Не удалось добавить предварительное требование',
    removePrerequisiteFailed: 'Не удалось удалить предварительное требование',
    markPrerequisitesReviewedFailed: 'Не удалось отметить предварительные требования как проверенные',
    acceptAllSkillsFailed: 'Не удалось принять все навыки',
    aiAnalyzingBanner: 'ИИ анализирует этот курс…',
    startedAgoOne: '(начато 1 минуту назад)',
    startedAgoCount: '(начато {count} мин. назад)',
    jobTimedOutBanner: 'Задача могла завершиться с ошибкой — проверьте позже или попробуйте повторить анализ.',
    reanalyzeRunningTooltip: 'Повторный анализ уже выполняется',
    rateLimitedTooltip: 'Ограничение по частоте. Повторите через {countdown}',
    reanalyzeTooltip: 'Повторно проанализировать навыки и предварительные требования с помощью ИИ',
    reanalyzeButton: 'Повторный анализ с ИИ',
    reanalyzingElapsed: 'Анализ… ({seconds} с)',
    reanalyzeAvailableIn: 'Повторный анализ будет доступен через {countdown}',
    skillsHeading: 'Навыки',
    skillsSubtitle: 'Навыки, назначенные каждому модулю. Предложенные ИИ метки отмечены до проверки.',
    accepting: 'Принятие…',
    acceptAll: 'Принять все',
    noUnreviewedModules: 'Нет непроверенных модулей',
    acceptAllTooltip: 'Принять все предложенные ИИ навыки',
    noModulesFound: 'Модули не найдены. Сначала добавьте модули в этот курс.',
    prerequisitesHeading: 'Предварительные требования',
    prerequisitesSubtitle: 'Определите, какие модули должны быть завершены перед другими. Предварительными требованиями можно назначать только более ранние модули (с меньшим порядковым номером).',
    hideGraph: 'Скрыть граф',
    showGraph: 'Показать граф',
    noPrereqEdges: 'Связи предварительных требований пока не определены.',
    needTwoModules: 'Для определения предварительных требований нужно как минимум два модуля.',
    colModule: 'Модуль',
    colRequires: 'Требует',
    colAddPrerequisite: 'Добавить требование',
    colReview: 'Проверка',
    dagModuleFallback: 'Модуль {index}',
    reanalyzeStartedToast: 'Повторный анализ запущен. Результаты через 1–2 минуты.',
    rateLimitedToast: 'Ограничение по частоте. Повторите через {phrase}.',
    rateLimitedDailyToast: 'Повторный анализ доступен раз в день. Попробуйте снова завтра.',
    aiDisabledToast: 'Функции ИИ сейчас отключены. Обратитесь к администратору.',
    reanalyzeNoPermissionToast: 'У вас нет прав на повторный анализ этого курса.',
    reanalyzeFailedToast: 'Повторный анализ не удался: {msg}',
    unknownErrorFallback: 'Неизвестная ошибка',
  },
  uz: {
    // Courses.js
    title: 'Kurslar',
    subtitle: 'Katalogingizdagi barcha kurslarni yarating, tahrirlang va boshqaring.',
    createButton: 'Kurs yaratish',
    statTotal: 'Barcha kurslar',
    statPublished: 'Nashr qilingan',
    statDrafts: 'Qoralamalar',
    statEnrollments: 'Yozilishlar',
    searchPlaceholder: 'Kurslarni qidirish...',
    clearSearch: 'Qidiruvni tozalash',
    filterAllPrices: 'Barcha narxlar',
    filterPaidOption: 'Pullik',
    filterFreeOption: 'Bepul',
    filterByPriceAria: "Narx bo'yicha filtr",
    sortNewest: 'Avval yangilari',
    sortOldest: 'Avval eskilari',
    sortTitleAsc: 'Nomi: A–Z',
    sortTitleDesc: 'Nomi: Z–A',
    sortPriceHighLow: 'Narx: yuqoridan pastga',
    sortPriceLowHigh: 'Narx: pastdan yuqoriga',
    sortAria: 'Saralash',
    resultsMeta: '{total} tadan {shown} tasi',
    countMeta: '{n} ta kurs',
    errorTitle: "Kurslarni yuklab bo'lmadi",
    errorDescription: "Internet aloqasini tekshirib, qaytadan urinib ko'ring.",
    loadingMessage: 'Kurslar yuklanmoqda...',
    noMatchTitle: 'Mos kurslar topilmadi',
    noMatchDescription: "Ko'proq kurslarni ko'rish uchun filtrlarni o'zgartiring yoki qidiruvni tozalang.",
    clearFilters: 'Filtrlarni tozalash',
    emptyTitle: "Hozircha kurslar yo'q",
    emptyDescription: "Katalogingizni shakllantirish va o'quvchilarni kutib olishni boshlash uchun birinchi kursingizni yarating.",
    emptyCreateButton: 'Kurs yaratish',
    statusPublished: 'Nashr qilingan',
    statusDraft: 'Qoralama',
    cardLessons: '{n} dars',
    cardStudents: "{n} o'quvchi",
    cardTests: '{n} test',
    menuEdit: 'Tahrirlash',
    menuAria: '{title}: amallar',
    menuPublish: 'Nashr qilish',
    menuUnpublish: 'Nashrdan olish',
    publishedToast: 'Kurs nashr qilindi',
    unpublishedToast: 'Kurs nashrdan olindi',
    publishFailed: "Nashr holatini o'zgartirib bo'lmadi",
    publishPermissionError: "Kursni nashr qilish yoki nashrdan olish faqat administratorlarga ruxsat etilgan",
    deleteDialogTitle: "Kursni o'chirasizmi?",
    deleteDialogBody: "kursi barcha darslari, testlari va yozilishlari bilan o'chiriladi. Bu amalni qaytarib bo'lmaydi.",
    dismissAria: 'Yopish',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    deletePermissionError: "Kurslarni o'chirish uchun ruxsatingiz yo'q",
    deletedToast: "Kurs o'chirildi",
    noAccess: "Sizda ushbu ma'lumotlarga kirish huquqi yo'q.",
    deleteFailed: "Kursni o'chirib bo'lmadi",

    // SkillsPrerequisitesTab.js
    removeSkillAria: "{name} ko'nikmasini olib tashlash",
    searchOrCreateSkillPlaceholder: "Ko'nikma qidiring yoki yarating...",
    addSkillDialogAria: "Ko'nikma qo'shish",
    createSkillOption: '"{query}" yaratish',
    startTypingSkills: "Ko'nikmalarni qidirish uchun yoza boshlang",
    skillsCatalogueUnavailableTitle: "Ko'nikmalar katalogi mavjud emas",
    skillsCatalogueUnavailableDesc: "Umumiy ko'nikmalar ro'yxatini yuklab bo'lmadi. Yangi ko'nikma yaratib biriktirish uchun quyida nomini yozishingiz mumkin.",
    durationNow: 'hozir',
    durationLessThanMinute: 'bir daqiqadan kam',
    durationHourOne: '1 soat',
    durationHoursCount: '{count} soat',
    durationMinuteOne: '1 daqiqa',
    durationMinutesCount: '{count} daqiqa',
    durationCombined: '{hourPart} va {minutePart}',
    reanalyzeModalTitle: 'AI bilan qayta tahlil qilish',
    reanalyzeModalBody1: 'Bu ushbu kursdagi ',
    reanalyzeModalBodyBold: "ko'rib chiqilmagan modullar",
    reanalyzeModalBody2: " uchun ko'nikmalar va oldingi talablar bo'yicha AI takliflarini qayta yaratadi. Ko'rib chiqilgan modullar o'zgartirilmaydi.",
    reanalyzeModalBody3: "Tahlil taxminan 1–2 daqiqa vaqt oladi. U ishlayotgan vaqtda platformadan foydalanishni davom ettirishingiz mumkin.",
    reanalyzeModalNote: "Qayta tahlil har bir kurs uchun 24 soatda bir marta bilan cheklangan.",
    starting: 'Boshlanmoqda…',
    runAnalysis: 'Tahlilni ishga tushirish',
    aiProposedPill: 'AI taklifi',
    aiProposedSkillsTooltip: "Ko'nikmalar AI tomonidan taklif qilingan va hali ko'rib chiqilmagan",
    reviewedPill: "Ko'rib chiqilgan",
    marking: 'Belgilanmoqda…',
    markReviewed: "Ko'rib chiqilgan deb belgilash",
    noSkillsAssigned: "Ko'nikmalar tayinlanmagan",
    addSkillButton: "Ko'nikma qo'shish",
    addSkillToModuleAria: "Ushbu modulga ko'nikma qo'shish",
    aiProposedPrereqTooltip: "Oldingi talablar AI tomonidan taklif qilingan va hali ko'rib chiqilmagan",
    aiPillShort: 'AI',
    none: "Yo'q",
    removePrerequisiteAria: '{title} oldingi talabini olib tashlash',
    selectModulePlaceholder: 'Modulni tanlang...',
    addButton: "Qo'shish",
    processingEllipsis: '…',
    noEarlierModules: "Oldingi modullar yo'q",
    loadingSkillsPrereqs: "Ko'nikmalar va oldingi talablar yuklanmoqda…",
    tryAgain: 'Qayta urinish',
    loadSkillsFailed: "Ko'nikmalar ma'lumotlarini yuklab bo'lmadi",
    addSkillFailed: "Ko'nikma qo'shib bo'lmadi",
    removeSkillFailed: "Ko'nikmani olib tashlab bo'lmadi",
    markReviewedFailed: "Ko'rib chiqilgan deb belgilab bo'lmadi",
    addPrerequisiteFailed: "Oldingi talabni qo'shib bo'lmadi",
    removePrerequisiteFailed: "Oldingi talabni olib tashlab bo'lmadi",
    markPrerequisitesReviewedFailed: "Oldingi talablarni ko'rib chiqilgan deb belgilab bo'lmadi",
    acceptAllSkillsFailed: "Barcha ko'nikmalarni qabul qilib bo'lmadi",
    aiAnalyzingBanner: 'AI ushbu kursni tahlil qilmoqda…',
    startedAgoOne: '(1 daqiqa oldin boshlangan)',
    startedAgoCount: '({count} daqiqa oldin boshlangan)',
    jobTimedOutBanner: "Vazifa muvaffaqiyatsiz tugagan bo'lishi mumkin — keyinroq tekshiring yoki qayta tahlil qilishga urinib ko'ring.",
    reanalyzeRunningTooltip: 'Qayta tahlil allaqachon ishlamoqda',
    rateLimitedTooltip: "Chastota cheklangan. {countdown} dan keyin qayta urining",
    reanalyzeTooltip: "Ko'nikmalar va oldingi talablarni AI bilan qayta tahlil qilish",
    reanalyzeButton: 'AI bilan qayta tahlil qilish',
    reanalyzingElapsed: 'Qayta tahlil qilinmoqda… ({seconds}s)',
    reanalyzeAvailableIn: "Qayta tahlil {countdown} dan keyin mavjud bo'ladi",
    skillsHeading: "Ko'nikmalar",
    skillsSubtitle: "Har bir modulga tayinlangan ko'nikmalar. AI taklif qilgan chiplar ko'rib chiqilguncha belgilangan.",
    accepting: 'Qabul qilinmoqda…',
    acceptAll: 'Barchasini qabul qilish',
    noUnreviewedModules: "Ko'rib chiqilmagan modullar yo'q",
    acceptAllTooltip: "AI taklif qilgan barcha ko'nikmalarni qabul qilish",
    noModulesFound: "Modullar topilmadi. Avval ushbu kursga modullar qo'shing.",
    prerequisitesHeading: 'Oldingi talablar',
    prerequisitesSubtitle: "Qaysi modullar boshqalardan oldin tugatilishi kerakligini belgilang. Faqat oldingi modullar (kichikroq tartib raqamiga ega) oldingi talab sifatida belgilanishi mumkin.",
    hideGraph: 'Grafikni yashirish',
    showGraph: "Grafikni ko'rsatish",
    noPrereqEdges: "Hali oldingi talab bog'lanishlari aniqlanmagan.",
    needTwoModules: "Oldingi talablarni belgilash uchun kamida ikkita modul kerak.",
    colModule: 'Modul',
    colRequires: 'Talab qiladi',
    colAddPrerequisite: "Oldingi talab qo'shish",
    colReview: "Ko'rib chiqish",
    dagModuleFallback: 'Modul {index}',
    reanalyzeStartedToast: 'Qayta tahlil boshlandi. Natijalar 1-2 daqiqada.',
    rateLimitedToast: 'Chastota cheklangan. {phrase} dan keyin qayta urining.',
    rateLimitedDailyToast: "Qayta tahlilni kuniga bir marta bajarishingiz mumkin. Ertaga qayta urinib ko'ring.",
    aiDisabledToast: "AI funksiyalari hozircha o'chirilgan. Administratoringizga murojaat qiling.",
    reanalyzeNoPermissionToast: "Ushbu kursni qayta tahlil qilish uchun ruxsatingiz yo'q.",
    reanalyzeFailedToast: 'Qayta tahlil amalga oshmadi: {msg}',
    unknownErrorFallback: "Noma'lum xatolik",
  },
};

export default courses;
